import lottie from 'lottie-web';
import { preloadImages } from '@data/preload-assets';
import { loadFonts } from '@loaders/FontLoader';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'LoadScene',
    });
  }

  async preload() {
    this.load.image('overlay-template', 'assets/GameAssets/overlay.png');
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');

    await loadFonts();
  }

  create() {
    this.screenOverlay = this.add.image(0, 0, 'overlay-template').setOrigin(0);

    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    preloadImages(this);
    this.assetsLoad();

    this.load.start();

    this.load.on(
      'progress',
      function () {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      function () {
        console.info('LoadScene complete');
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);

        this.loadingAnim.anim.addEventListener('complete', () => {
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    // rexflashplugin (used by GameScene + LV2GameScene for blinking cursors)
    this.load.plugin('rexflashplugin', 'assets/Plugins/rexflashplugin.min.js', true);

    // StartScene multiatlases
    this.load.multiatlas(
      'frontTree',
      'assets/G5 Prereq Game Anims/Start Scene Anims/treesFrontAnim.json',
      'assets/G5 Prereq Game Anims/Start Scene Anims',
    );
    this.load.multiatlas(
      'backTree',
      'assets/G5 Prereq Game Anims/Start Scene Anims/treesBackAnim.json',
      'assets/G5 Prereq Game Anims/Start Scene Anims',
    );
    this.load.multiatlas(
      'birdFly',
      'assets/G5 Prereq Game Anims/Start Scene Anims/birdAnim.json',
      'assets/G5 Prereq Game Anims/Start Scene Anims',
    );
    this.load.multiatlas(
      'truckDrive',
      'assets/G5 Prereq Game Anims/Start Scene Anims/truckDriveAnim.json',
      'assets/G5 Prereq Game Anims/Start Scene Anims',
    );

    // GameScene atlases / multiatlases
    this.load.atlas(
      'confetti',
      'assets/GameScene/confettiAnim.png',
      'assets/GameScene/confettiAnim.json',
    );
    this.load.multiatlas(
      'lever',
      'assets/G5 Prereq Game Anims/Game Scene Anims/leverAnim.json',
      'assets/G5 Prereq Game Anims/Game Scene Anims',
    );
    this.load.multiatlas(
      'wind',
      'assets/G5 Prereq Game Anims/Game Scene Anims/windLeavesAnim.json',
      'assets/G5 Prereq Game Anims/Game Scene Anims',
    );
    this.load.multiatlas(
      'shake',
      'assets/G5 Prereq Game Anims/Game Scene Anims/treeShake.json',
      'assets/G5 Prereq Game Anims/Game Scene Anims',
    );
    this.load.multiatlas(
      'spotlight',
      'assets/spotlight/spotlightAnimNew.json',
      'assets/spotlight',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/confetti/confettiAnimNew.json',
      'assets/confetti',
    );

    // Audio (used across both levels)
    this.load.audio('BirdsWingBG', 'assets/audio/BirdsWingBG.mp3');
    this.load.audio('mainBG', 'assets/audio/mainBG.mp3');
    this.load.audio('CorrectAnswer', 'assets/audio/CorrectAnswer.mp3');
    this.load.audio('IncorrectAnswer', 'assets/audio/IncorrectAnswer.mp3');
    this.load.audio('HarvesterArmLift', 'assets/audio/HarvesterArmLift.mp3');
    this.load.audio('harvesterRunning', 'assets/audio/harvesterRunning.mp3');
    this.load.audio('treeShakingGameScene', 'assets/audio/treeShakingGameScene.mp3');
    this.load.audio(
      'WrongAnswerharvesterShake',
      'assets/audio/WrongAnswerharvesterShake.mp3',
    );
    this.load.audio('TruckHornL2StartScene', 'assets/audio/TruckHornL2StartScene.mp3');
    this.load.audio('RewardRevealL1', 'assets/audio/RewardRevealL1.mp3');
    this.load.audio('LogoReveal', 'assets/audio/LogoReveal.mp3');
    this.load.audio('BoxAppearingOnTruck', 'assets/audio/BoxAppearingOnTruck.mp3');
    this.load.audio('BoxComingOut', 'assets/audio/BoxComingOut.mp3');
    this.load.audio('orangeOnConveyor', 'assets/audio/orangeOnConveyor.mp3');
    this.load.audio('large-truck-drive-off', 'assets/audio/large-truck-drive-off.mp3');
  }
}
